import { ActionContext } from 'vuex';

import { getLocalState } from '@/common/utils/store';

import calculationApi from '../../api/Calculation';
import { CALCULATION_COMMON_MUTATIONS_NAME } from './name';
import { TCalculationCommonState } from './types';

export async function searchUploadingDataStatus(context: ActionContext<TCalculationCommonState, unknown>) {
  try {
    const info = (await calculationApi.getCalculationActiveInfo()).data;
    context.commit(getLocalState(CALCULATION_COMMON_MUTATIONS_NAME.setUploadingDataStatus), info);
  } catch (error) {
    console.error(error);
  }
}
